export const navbarData = {
  homeTitle: 'Movimento Codernista',
  blogTitle: 'Blog Movimento Codernista',
}

export const footerData = {
  author: 'Movimento Codernista',
  aboutAuthor:
    'O Movimento Codernista é um projeto focado em transformar a sua vida desenvolvedor, enriquecendo a sua jornada, com o propósito único de aumentar a sua empregabilidade e tornar-lhe referência técnica no mercado.',
  aboutCourse:
    'Quer transformar a sua carreira em TI, aumentar a sua empregabilidade e se tornar referência no mercado? Compartilhe conosco o seu interesse!',
  aboutTheSite:
    'Este é um site de blog pessoal construído com Nuxt3, TailwindCSS, NuxtContent, Nuxt Icon. Atualmente está implantado na Vercel.',
}

export const defaultData = {
  date: new Date('2025-01-01'),
}

export const lp1Data = {
  title: 'Dê um Salto na Sua Carreira de Desenvolvedor!',
  description:
    'Cansado de se sentir estagnado? Quer alcançar o próximo nível na sua jornada como desenvolvedor? Prepare-se para decolar!',
}

export const homePage = {
  title: 'Bem-vindo ao Meu Site',
  description:
    'Obtenha artigos, dicas, recursos de aprendizado e mais sobre Desenvolvimento Web, Javascript, Typescript, NodeJs, Vue e Nuxt.',
}

export const blogPage = {
  title: 'Bem-vindo ao Blog do Movimento Codernista',
  description:
    'Conteúdo para transformar a sua carreira na programação e se tornar referência no mercado!',
}

export const postsPage = {
  title: 'Todos os posts',
  description: 'Aqui você vai encontrar o post que está procurando.',
  ogDescription: 'Aqui você vai encontrar o post que está procurando.',
}

export const backendPage = {
  title: 'Desenvolvedor Backend',
  description:
    'Mantenha-se à frente no mundo do desenvolvimento backend! Artigos atualizados sobre as tecnologias e práticas mais relevantes para construir aplicações eficientes e escaláveis.',
  ogDescription: 'Mantenha-se à frente no mundo do desenvolvimento backend!',
}

export const carreiraPage = {
  title: 'Carreira em TI',
  description:
    'Impulsione sua carreira em TI! Dicas de marketing pessoal, criação de portfólios impactantes, desenvolvimento de power skills e insights profissionais para alcançar seus objetivos na área de tecnologia.',
  ogDescription: 'Impulsione sua carreira em TI! Dicas de sucesso.',
}

export const dadosPage = {
  title: 'Dados',
  description:
    'Explore o universo dos dados! Aprenda sobre bancos de dados (SQL e NoSQL), ingestão eficiente, Databricks, ferramentas de BI e as melhores práticas para trabalhar com grandes volumes de informação.',
  ogDescription: 'Explore o universo dos dados! Aprenda sobre bancos de dados.',
}

export const ferramentasPage = {
  title: 'Ferramentas de Desenvolvimento',
  description:
    'Aumente sua produtividade e automatize seu fluxo de trabalho! Descubra as melhores IDEs, Sonar, GIT, Markdown, Docker e ferramentas de CI/CD para desenvolvedores eficientes e modernos.',
  ogDescription: 'Aumente sua produtividade e automatize seu fluxo de trabalho!',
}

export const tagPage = {
  title: 'Tags',
  description:
    'Aqui estão todas as tags que foram mencionadas nos posts, para facilitar a sua pesquisa.',
  ogDescription: 'Aqui estão todas as tags que foram mencionadas nos posts.',
}

export const routesData = ['/', 'sitemap.xml', 'rss.xml', '/blog', '/blog/posts', '/tags']

export const seoData = {
  title: `Movimento Codernista`,
  ogTitle: `Blog do Movimento Codernista`,
  description: `Conteúdo para transformar a sua carreira na programação!`,
  twitterDescription: `Conteúdo para transformar a sua carreira na programação!`,
  image:
    'https://res.cloudinary.com/dmecmyphj/image/upload/v1673548905/nuxt-blog/cover_ntgs6u.webp',
  mySite: 'https://movimento.codernista.com.br',
  twitterHandle: '@codernista',
  mailAddress: 'codernista@gmail.com',
}

export const socialLinks = {
  githubLink: 'https://github.com/codernista',
  instagramLink: 'https://www.instagram.com/codernista',
  youtubeLink: '#',
  tiktokLink: '#',
}

export const siteMetaData = [
  {
    name: 'description',
    content: seoData.description,
  },
  // Teste em: https://developers.facebook.com/tools/debug/ ou https://socialsharepreview.com/
  { property: 'og:site_name', content: seoData.mySite },
  { property: 'og:type', content: 'website' },
  {
    property: 'og:url',
    content: seoData.mySite,
  },
  {
    property: 'og:title',
    content: seoData.ogTitle,
  },
  {
    property: 'og:description',
    content: seoData.description,
  },
  {
    property: 'og:image',
    content: seoData.image,
  },
  // Teste em: https://cards-dev.twitter.com/validator ou https://socialsharepreview.com/
  { name: 'twitter:site', content: seoData.twitterHandle },
  { name: 'twitter:card', content: 'summary_large_image' },
  {
    name: 'twitter:url',
    content: seoData.mySite,
  },
  {
    name: 'twitter:title',
    content: seoData.ogTitle,
  },
  {
    name: 'twitter:description',
    content: seoData.twitterDescription,
  },
  {
    name: 'twitter:image',
    content: seoData.image,
  },
]
